//专门来放mutation里用到的方法常量值

export const ACCESS_TOKEN = 'Access-Token'//存放token